var $ = require('jquery');
import './contrib/tooltipsy';


export const SCROLL_TO_DURATION = 200;
export const TRANSITION_DURATION = 375;


export function pageSetup() {
    $.get('/csrf/', {cache: false});  // we need a fresh CSRF token

    fixMultipleSponsorsPosition();
    sponsorContentExplanationTooltip();
}


function fixMultipleSponsorsPosition() {
    // we want the the multiple sponsor logos on the right side (on desktop)
    // to vertically align correctly at the top
    let $multipleSponsors = $('.multiple-sponsors-container');
    if ($multipleSponsors.length) {
        let $formOuter = $('.asmt-container .asmt-form-outer');
        let top = (
            parseInt($formOuter.css('padding-top').replace('px', ''), 10) +
            $formOuter.position().top
        );
        $multipleSponsors.css('top', `${top}px`);
    }
}


function sponsorContentExplanationTooltip() {
    let $sponsorContentHelp = $('.asmt-container .sponsor-content-explanation-help');

    let options = {
        alignTo: 'element',
        className: 'asmt-sponsor-content-explanation-help-tooltip',
        delay: 0,
        offset: $(window).width() > 590 ? [0, 1] : [-1, 1]
    };
    if ($('html').hasClass('touchevents')) {
        options.showEvent = 'click';
        options.hideEvent = 'click';
    }

    if ($sponsorContentHelp.length) {
        $sponsorContentHelp.tooltipsy(options);
    }
}



// WEBPACK FOOTER //
// ./src/misc.js